import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  headerContainer: (theme, { embed }) => css`
    background-color: ${theme.colors.background.white};
    margin-bottom: ${embed ? theme.spacing.xxs : 0};
  `,

  navProfile: css`
    display: flex;
    align-items: center;
    cursor: pointer;
  `,

  navContainer: theme => css`
    position: relative;
    padding: ${theme.spacing.xs} 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${theme.spacing.xs};
    background: ${theme.colors.background.white};
  `,

  navLogo: (_, { conexaLogo }) => css`
    max-width: ${conexaLogo ? '135px' : '150px'};
    max-height: 40px;
  `,

  navContainerBreadcrumb: theme => css`
    position: relative;
    padding: ${theme.spacing.xs} 0;
    background-color: ${theme.colors.brand.primary[300]};
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width: ${theme.grid.breakpoint.md}) {
      overflow-y: hidden;

      ::-webkit-scrollbar {
        display: none;
      }
    }
  `,

  navListItems: theme => css`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: ${theme.spacing.lg};
    white-space: nowrap;

    @media (max-width: ${theme.grid.breakpoint.md}) {
      gap: ${theme.spacing.sm};
    }
  `,

  navItem: theme => css`
    display: flex;
    position: relative;
    align-items: center;
    gap: ${theme.spacing.xxs};
    color: ${theme.colors.background.white};
    cursor: pointer;
    white-space: nowrap;

    @media (max-width: ${theme.grid.breakpoint.md}) {
      &:last-child {
        padding-right: ${theme.spacing.xs};
      }
    }
  `,

  navItemText: theme => css`
    ${theme.typography.paragraphSmall}
    font-weight: ${theme.fontWeights.bold};
    position: relative;
  `,

  navItemActiveText: theme => css`
    ${theme.typography.paragraphSmall}
    font-weight: ${theme.fontWeights.bold};
    position: relative;

    &:after {
      content: '';
      position: absolute;
      height: 3px;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${theme.colors.brand.secondary[300]};
      border-radius: ${theme.border.radius.lg};
    }
  `,

  navItemWithNotification: theme => css`
    &:before {
      content: '';
      position: absolute;
      left: -${theme.spacing.xs};
      width: ${theme.spacing.xxs};
      height: ${theme.spacing.xxs};
      border-radius: ${theme.border.radius.full};
      margin-right: ${theme.spacing.xxs};
      background-color: ${theme.colors.brand.secondary[300]};
    }
  `,
})

export default useStyles
